// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__4s8Ut","spin":"styles_spin__pzZrl","fixed":"styles_fixed__Br3Av","small":"styles_small__tMOUg"};